<template>
  <zm-banner class="opc-addon-info-banner" type="info">
    <div class="opc-addon-info-banner__message">
      {{ t('billing.addon.already_included_info_banner', { planName, basePlanNameOrBasePlanNames: basePlanName }) }}
    </div>
  </zm-banner>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  planName: {
    type: String,
    required: true,
  },
  basePlanName: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.opc-addon-info-banner {
  margin-bottom: 16px;
  background-color: var(--zoom-color-fill-subtler-primary, #F2F8FF);

  :deep {
    .zbo-banner {
      &__body {
        padding: 0;
      }
      &__content {
        display: flex;
        align-items: center;
      }
    }
  }

  &__message {
    flex-grow: 1;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  }
}
</style>

